import React from 'react';
import './Companies.css';

function Companies() {
  return (
    <div>
      <section className="c-wrapper">
        <div className="paddins innerWidth flexCenter c-container">
            <img src="./equinix.png" alt="" />
            <img src="./prologis.png" alt="" />
            <img src="./realty.png" alt="" />
            <img src="./tower.png" alt="" />
        </div>
      </section>
    </div>
  )
}

export default Companies
